import { Box } from '@mui/material';
import { Container, type ContainerProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCustom } from '@/hooks/use-custom';
import { Logo } from '../components/logo';

const HeaderContainer = styled(Container)<ContainerProps>(({ theme }) => ({
  maxWidth: '85% !important',
  width: '95%',
  padding: `${theme.spacing(2)} !important`,
  [theme.breakpoints.up('lg')]: {
    maxWidth: `${theme.breakpoints.values.xl * 1.25}px !important`,
  },
  [theme.breakpoints.down('lg')]: {
    maxWidth: `${theme.breakpoints.values.md * 0.9}px !important`,
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: `${theme.breakpoints.values.md * 1}px !important`,
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: theme.breakpoints.values.sm,
    width: '100%',
  },
}));

export const Header: React.FC = () => {
  const { layoutConfig } = useCustom();

  return layoutConfig?.layout === 'space-between' ? (
    <Box bgcolor="background.paper">
      <HeaderContainer>
        <Logo />
      </HeaderContainer>
    </Box>
  ) : null;
};
